import React from 'react';
import { useTranslation } from 'react-i18next';
import type { SupportedCurrencyItem } from '../context/CurrencyContext';

const WRAP: Record<NonNullable<CurrencySelectorProps['variant']>, string> = {
  workspace:
    'inline-flex items-center rounded-md border border-blue-600 bg-blue-800/70 px-1.5 py-px text-[10px] font-medium text-blue-50 shadow-sm',
  storefront:
    'inline-flex h-8 items-center rounded-full border border-slate-300 bg-white px-1.5 py-0 text-[10px] font-medium text-slate-700 shadow-sm',
};

const SELECT: Record<NonNullable<CurrencySelectorProps['variant']>, string> = {
  workspace: 'bg-transparent pr-2 text-[10px] font-medium outline-none focus-visible:ring-0',
  storefront: 'bg-transparent pr-2 text-[10px] font-medium text-slate-800 outline-none focus-visible:ring-0',
};

type CurrencySelectorProps = {
  value: string;
  options: SupportedCurrencyItem[];
  onChange: (value: string) => void;
  variant?: 'workspace' | 'storefront';
  fullWidth?: boolean;
};

function CurrencySelector({
  value,
  options,
  onChange,
  variant = 'workspace',
  fullWidth = false,
}: CurrencySelectorProps) {
  const { t } = useTranslation();
  const list =
    options?.length > 0
      ? options
      : [{ id: '', code: value, name: null, symbol: null, sortOrder: 0 }];
  const wrap = [
    WRAP[variant],
    fullWidth ? '!flex w-full min-w-0 [&_select]:!w-full [&_select]:min-w-0' : '',
  ]
    .filter(Boolean)
    .join(' ');
  const select = [SELECT[variant], fullWidth ? '!w-full' : ''].filter(Boolean).join(' ');
  return (
    <div className={wrap}>
      <select
        className={select}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        aria-label={t('common.currency')}
      >
        {list.map((cur) => {
          return (
            <option key={cur.id || cur.code} value={cur.code} className="bg-white text-slate-900">
              {cur.code}
            </option>
          );
        })}
      </select>
    </div>
  );
}

export default CurrencySelector;
